import { errorCode, rateLimitedMessage } from '@infrastructure/admin-security-api';
import { securityMessage } from '../admin/settings/access/SecurityParts';
// Backend codes of the Rebels MCP portal endpoints (QPortal.Backend.Mcp McpConsentService / McpConnectionService in the
// Rebels solution). Admin-security codes (STEP_UP_REQUIRED, STRONG_SESSION_REQUIRED, SESSION_INVALID, FORBIDDEN, ...)
// and RATE_LIMITED with retryAfterSeconds reuse the existing admin-security mapping.
const mcpMessages = {
    MCP_CONSENT_NOT_FOUND: 'This connection request is not available. It may already have been used. Start connecting again from the app.',
    MCP_CONSENT_EXPIRED: 'This connection request expired. Start connecting again from the app.',
    MCP_CONSENT_ALREADY_DECIDED: 'This connection request was already answered. Start connecting again from the app if you still want to connect it.',
    MCP_NOT_ELIGIBLE: 'Your account cannot connect this app.',
    MCP_SCOPE_INVALID: 'Choose from the requested permissions. Read access is always needed.',
    MCP_ADMIN_SECURITY_NOT_ENFORCED: 'Admin connections are only possible when passkey or authenticator sign-in is required for this portal.',
    MCP_CONNECTION_NOT_FOUND: 'This connection is no longer active. The list has been reloaded.',
    MCP_PAGE_INVALID: 'The list could not be loaded. Reload the page.',
    ADMIN_SECURITY_DISABLED: 'This needs passkey or authenticator sign-in, which is not yet available for this portal.',
    STEP_UP_PURPOSE_INVALID: 'This confirmation is not available. Reload the page and try again.',
    MCP_DECISION_RETRY: 'The Rebels portal was busy with another confirmation at the same moment. Nothing was changed. Confirm again.'
};
export const mcpMessage = (error) => {
    const code = errorCode(error);
    if (code === 'RATE_LIMITED')
        return rateLimitedMessage(error);
    return mcpMessages[code] ?? securityMessage(error);
};
// With the kill switch off (Mcp:Enabled=false) the MCP routes do not exist: a 404 without a backend code.
export const connectorsSwitchedOff = (error) => error?.response?.status === 404 && errorCode(error) === 'REQUEST_FAILED';
const scopeTitles = {
    'hours:read': 'View your hours',
    'hours:draft': 'Save hours as a draft',
    'admin:read': 'View admin information',
    'admin:approve': 'Prepare approvals and rejections',
    // add-admin-mail-actions-and-mcp-audit (design §6.1): MCP prepares, the admin confirms each e-mail with a fresh step-up.
    'admin:mail': 'Prepare e-mails (you confirm each one in the Rebels portal)'
};
export const scopeTitle = (scope) => scopeTitles[scope] ?? scope;
// [Rebels] The coarse reason of the account's own ineligibility (McpGrantDecision.IneligibleReason), never about another account.
const ineligibleReasons = {
    NOT_APPROVED: 'Your profile is not approved yet. Once a Rebels administrator approves it, you can connect apps.',
    EMAIL_UNCONFIRMED: 'Your e-mail address is not confirmed yet. Confirm it first, then start connecting again.',
    ROLE_NOT_ELIGIBLE: 'This account type cannot connect this app.',
    ADMIN_SECURITY_NOT_ENFORCED: 'Admin connections are only possible when passkey or authenticator sign-in is required for this portal.',
    ACCOUNT_UNAVAILABLE: 'This account is not active.'
};
export const ineligibleText = (reason) => (reason ? ineligibleReasons[reason] : undefined);
export { formatDateTime } from '../admin/settings/access/SecurityParts';
